<template>
  <v-sheet class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 as-box-title as-bg-color-100"
    elevation="4" height="150" rounded max-width="600" width="100%" mb="6">
    <div>
      <div class="text-h5 font-weight-medium pa-2">
        DIRECCIÓN GENERAL LOGÍSTICA<br>UNIDAD DE MATERIAL BÉLICO
      </div>
      <p class="text-body-2 mb-4">
        Registro clasificado de armas de fuego, municiones y explosivos de uso Militar
      </p>
    </div>
  </v-sheet>


  <div class="mx-5 my-5">
    <v-card>
      <v-card-title>
        <v-text-field v-model="search" append-icon="mdi-magnify" color="light-blue-darken-4" label="Buscar" single-line
          hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="registros" :search="search">
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn small @click="abrirDialogo(item)">
            Ver Certificado
          </v-btn>
        </template>
      </v-data-table>


      <v-dialog v-model="dialogoAbierto" max-width="500px">
        <v-card>
          <v-card-title>
            Contenido Individual
          </v-card-title>
          <v-card-text>
            <div>
              <strong>CODIGO DE BOLETA:</strong> {{ codigo }}
            </div>
            <div>
              <strong>CI:</strong> {{ ci }}
            </div>
            <div>
              <strong>Nombre:</strong> {{ nombre }}
            </div>
            <div>
              <strong>Apellido Paterno:</strong> {{ apellidoPaterno }}
            </div>
            <div>
              <strong>Apellido Materno:</strong> {{ apellidoMaterno }}
            </div>
            <!-- Agrega aquí más campos con las variables que deseas mostrar -->
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
            <v-btn text @click="generarCertificacion">Certificar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


    </v-card>
  </div>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { defineComponent } from 'vue';
import Personal from "@/services/Personal";
import { VDataTable, VDialog, VCard, VCardTitle, VCardText, VCardActions, VBtn } from 'vuetify/labs/VDataTable'

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default defineComponent({
  name: 'AdminPage',
  components: {
    VDataTable,
    VDialog,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VBtn,
  },
  data() {
    var registros;
    const personal = new Personal();
    return {
      registros,
      personal,
      search: '',
      fecha: '',
      qrCodeData: '',
      dialogoAbierto: false,
      cod_personal: '',
      ci: '',
      nombre: '',
      apellidoPaterno: '',
      apellidoMaterno: '',
      headers: [
        { key: 'name', align: 'center', sortable: true },
        { key: 'cod_personal', title: 'Codigo Personal' },
        { key: 'carnet', title: 'Cedula Identidad' },
        { key: 'nombres', title: 'Nombres' },
        { key: 'apellido_paterno', title: 'Apellido Paterno' },
        { key: 'apellido_materno', title: 'Apellido Materno' },
        { key: 'actions', title: 'Acciones', align: 'center' },
        // {
        //   key: 'nombre',
        //   title: 'Nombre Completo',
        //   value: (item) => `${item.nombres} ${item.apellido_paterno} ${item.apellido_materno}`, // Concatenación de nombres y apellido paterno
        // },
      ],


    }
  },
  methods: {
    abrirDialogo(item) {
      this.codigo = item.cod_personal;
      this.ci = item.carnet;
      this.nombre = item.nombres;
      this.apellidoPaterno = item.apellido_paterno;
      this.apellidoMaterno = item.apellido_materno;
      this.dialogoAbierto = true;

    },
    cerrarDialogo() {
      this.dialogoAbierto = false;
    },
    generarCertificacion() {
      // Configura el contenido de tu certificación aquí
      this.fecha = new Date().toLocaleDateString();
      const qrCodeData = `CERTIFICADO de reposicion de pistola N° 458/2023\n perteneciente a: ${this.nombre} ${this.apellidoPaterno} ${this.apellidoMaterno}\nes extendido en fecha ${this.fecha}`;
      const qrCodeImageDefinition = {
        qr: qrCodeData,
        fit: 100,
        alignment: 'right',
        width: 'auto',
        margin: [0, 10, 5, 0],
      };

      const documentDefinition = {

        content: [
          qrCodeImageDefinition,
          {
            text: 'CERTIFICADO N° 458/2023',
            style: 'header',
            alignment: 'center',
            margin: [0, 0, 0, 0],

          },
          {
            text: 'La Unidad de Material Bélico del Ministerio de Defensa, en atención a la solicitud presentada por el Interesado:',
            style: 'body', // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [35.05, 10, 35.05, 0], // Ajusta el margen superior según tus necesidades.
          },
          {
            text: 'C E R T I F I C A:',
            style: 'subheader', // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [45.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
            bold: true,
          },
          {
            text: `Al Señor: ${this.nombre} ${this.apellidoPaterno} ${this.apellidoMaterno}\nCedula de Identidad: ${this.ci}`,
            style: 'body',
            alignment: 'center',
            margin: [0, 0, 0, 20],
          },
          {
            text: `EL DEPÓSITO BANCARIO EN LA CUENTA\n(VARIOS) DEL  MINISTERIO DE DEFENSA. Nº 1-24276087\nREGISTRÓ DE TESORERÍA Nº 74590\nREGISTRO DE RUBRO Nº 15990.`,
            style: 'subheader',
            alignment: 'center',
          },
          {
            text: 'Realizó el RESARCIMIENTO ECONÓMICO por concepto de 1 (Un) Sable Dorado\npara el Grado de General de Ejército,  de acuerdo al siguiente detalle:',
            style: 'body',
            margin: [35.05, 10, 35.05, 0],
          },
          {
            text: 'CARGADOR DE PISTOLA:',
            style: 'subheader', // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [45.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
            bold: true,
          },
          {
            text: ' CALIBRE\nMARCA\nMODELO\nSERIE\nINDUSTRIA',
            style: 'body', // Puedes definir un estilo específico para este texto si lo deseas.
            margin: [200.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
          },
          {
            text: 'Advertencia',
            style: 'body',
            margin: [35.05, 10, 35.05, 0],
          },
          {
            text: '-	La Certificación cuenta con el respaldo legal de la Dirección de Jurídica Nº\n-	El presente Certificado es válido solo para trámites administrativos dentro las FF.AA.\n-	Cualquier alteración, borrón, raspadura o enmienda, anula el presente Certificado.\n-	El pago para la Certificación fue voluntaria por la perdida, robo y/o extravío del bien.',
            style: 'body',
            margin: [35.05, 10, 35.05, 0],
            fontSize: 10,
          },
          {
            text: `La Paz, enero ${this.fecha}`, // Aquí se utiliza la propiedad fecha
            style: 'subheader',
            alignment: 'right',
            margin: [35.05, 10, 35.05, 0],
          },


          // Agrega más contenido según sea necesario
        ],

        styles: {
          header: {
            fontSize: 16,
            bold: true,
            margin: [0, 56.7, 0, 20],
          },
          subheader: {
            fontSize: 14,
            margin: [0, 0, 0, 10],
          },
          body: {
            fontSize: 12,
          },
        },
      };

      // Genera y descarga el PDF
      pdfMake.createPdf(documentDefinition).open();
    },
  },
  async created() {
    this.registros = await this.personal.index();
  }
});
</script>